module.exports = __webpack_public_path__ + "img/wechat.7f0cf940.svg";